export function formatCurrency(value: number): string {
  return (value / 100).toLocaleString(undefined, {
    style: "currency",
    currency: "EUR",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
